export default {
  data() {
    return {
      isIE: false,
    };
  },
  created() {
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
      this.isIE = true;
    }
  },
  methods: {
    /**
     * @param {object} response
     * @param {boolean} alert
     * @param {boolean} updateTable
     * @param {string} emit
     */
    responseHandler(
      response,
      alert = true,
      updateTable = true,
      emit = false,
    ) {
      const message = response?.data?.message
        || response?.data?.messages?.[0]?.message
        || response?.data?.messages?.[0]
        || null;

      const type = response?.data?.type
        || response?.data?.messages?.[0]?.type
        || null;

      const successCodes = [200, 201];

      if (successCodes.includes(response?.status)) {
        if (alert && message) {
          window.GlobalEvents.fire('alert', [{ message, type: type || 'success' }]);
        }

        if (updateTable) {
          window.GlobalEvents.fire('update-data-table');
        }

        if (emit) {
          this.$emit(emit, response.data);
        }

        return response?.data;
      }

      if (alert && message) {
        window.GlobalEvents.fire('alert', [{ message, type: type || 'error' }]);
      }

      if (this.errors?.record) {
        this.errors.record(response.data.errors);
      }

      if (emit) {
        this.$emit(emit, false);
      }

      return false;
    },
  },
};
